export enum ConfigurationsKey {
    PARTIAL_PAYMENTS = 'partial_payments.configuration'
}